import { render, staticRenderFns } from "./adminTrainingList.vue?vue&type=template&id=70dde37c&"
import script from "./adminTrainingList.vue?vue&type=script&lang=js&"
export * from "./adminTrainingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports